

module.exports = require('./DialogWrap');



// WEBPACK FOOTER //
// ./_rc-dialog-6.1.1/src/index.js